import { createMuiTheme } from '@material-ui/core/styles';

export const getTheme = (dark: boolean) =>
  createMuiTheme({
    palette: {
      type: dark ? 'dark' : 'light',
    },
  });
